import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  toggleModalAction,
  toggleToastAction,
  editMutationAction,
} from "store/actions/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Title from "components/title/Title";
import ApiCallHandler from "shared/js/ApiCallHandler";
import URLS from "shared/js/urls";
import ShowActions from '../../../../shared/components/showActions/ShowActions';
import { getActiveEnterprise, getMeaningfulDate, getCountryInfo } from '../../../../shared/js/utils';
import CreateDealExpense from "./CreateDealExpense";
import { withRouter } from 'react-router-dom';
import { getDealStatsAction } from '../../../../store/actions/actions';
import {NoItems, Table} from "@kehillahglobal/ui";
import Note from "shared/components/note/Note";
import { Descriptions } from "documentation/Descriptions";
import ModalContent from "shared/components/modal-content/ModalContent";
class ListDealExpenses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showToast: false,
      newlyCreated: {},
      assets: [],
      expenseTypes: [],
      msg: "",
      toast_type: "",
      routeName: "",
      currentData: {
        asset: "",
        type: "",
        id: "",
        period_start: "",
        period_end: "",
        amount: "",
      },
      showActions: false,
      id: "",
    };
  }

  showOppExpenseDeleteModal = (item) => {
    this.props.toggleModal({
      show: true,
      props: {
        title: `Delete "${item?.expense_type?.name}"`,
        children: (
          <ModalContent content={"Would you like to delete this record ?"} />
        ),
        themeColor: "maroon",
        cancel: true,
        okay: {
          text: "Yes",
          function: () => this.handleDeleteDealExpense(item),
        },
      },
    });
  };
  toggleShowMoreOptions = (item) => {
    if (!item?.id) {
      this.setState({
        showActions: false,
        id: "",
      });
    } else {
      this.setState({
        showActions: true,
        id: item?.id,
      });
    }
  };
  prepareTableData = () => {
    let { dealExpenses } = this.props;
    let tableData = [];
    if (
      dealExpenses &&
      dealExpenses.length > 0
    ) {
      dealExpenses.forEach((item, index) => {
        tableData.push([
          <p>{index + 1}</p>,
          <p onClick={() => this.toggleShowAllExpenseInfo(item)}>
            {item?.expense_type?.name}
          </p>,
          <p onClick={() => this.toggleShowAllExpenseInfo(item)}>
            {parseFloat(item?.amount)?.toFixed(2)}
          </p>,
          <p onClick={() => this.toggleShowAllExpenseInfo(item)}>
            {getMeaningfulDate(item?.transaction_date?.split("T")[0])}{" "}
          </p>,
          <p onClick={() => window.open(item?.receipt, "_blank")}>
            {item?.receipt ? "View" : "No Receipt"}
          </p>,
          <p onClick={() => this.toggleShowAllExpenseInfo(item)}>
            {item?.reference_id
              ? item?.reference_id?.length > 20
                ? item?.reference_id?.substring(0, 20) + " ...."
                : item?.reference_id
              : "No Ref. Id"}{" "}
          </p>,

          <ShowActions
            onEdit={this.handleAddOrEditDealExpense}
            onDelete={this.showOppExpenseDeleteModal}
            item={item}
            id={this.state.id}
            toggleShowMoreOptions={this.toggleShowMoreOptions}
            show={this.state.showActions}
          />,
        ]);
      });
    }
    return tableData;
  };

  toggleShowAllExpenseInfo = (expense) => {
    this.props.toggleModal({
      show: true,
      props: {
        title: `Expense Details`,
        children: this.renderExpenseFullDetails(expense),
        themeColor: "var(--app-theme)",
        size: "medium",
      },
    });
  };

  renderExpenseFullDetails = (expense) => {
    let { currentEnterprise } = this.props;
    let { currency } = getCountryInfo(currentEnterprise?.currency);
    return (
      <div className="detail-main-container">
        <div>
          <p>Type</p>
          <span>{expense?.expense_type?.name}</span>
        </div>
        <div>
          <p>Amount</p>
          <span>
            {currency?.symbol} {parseFloat(expense?.amount)?.toFixed(2)}
          </span>
        </div>
        <div>
          <p>Receipt</p>
          {expense?.receipt ? (
            <span onClick={() => window.open(expense?.receipt, "_blank")}>
              View Receipt
            </span>
          ) : (
            <span>N/A</span>
          )}
        </div>
        <div>
          <p>Transaction Date</p>
          <span>
            {getMeaningfulDate(expense?.transaction_date?.split("T")[0])}
          </span>
        </div>
        <div>
          <p>Reference ID</p>
          <span>{expense?.reference_id}</span>
        </div>
        <div>
          <p>Notes</p>
          {expense?.description ? (
            <p
              style={{
                fontWeight: "normal",
                fontSize: "1rem",
                textAlign: "justify",
                color: "black",
              }}
            >
              {expense?.description}
            </p>
          ) : (
            <span>N/A</span>
          )}
        </div>
      </div>
    );
  };

  showDealExpenses = () => {
    let { dealExpenses, currentEnterprise } = this.props;
      let { currency } = getCountryInfo(currentEnterprise?.currency);
    return (
      <div>
        <Note note={Descriptions.EXPENSE} />
        <Title
          className="text-toggler"
          onClick={() => this.handleAddOrEditDealExpense()}
        >
          Add Expenses <FontAwesomeIcon icon={faPlus} />
        </Title>
        <div style={{ borderRadius: 10 }}>
          {dealExpenses && dealExpenses.length ? (
            <Table
              columns={[
                "#",
                "Expense Type",
                `Amount (${currency?.symbol})`,
                "Transaction Date",
                "Receipt",
                "Ref. ID",
                "Actions",
              ]}
              data={this.prepareTableData()}
              hoverAnimation={false}
            />
          ) : (
            <NoItems text="No expense recorded yet." />
          )}
        </div>
      </div>
    );
  };

  close = () => {
    this.props.toggleModal({ show: false });
  };

  handleAddOrEditDealExpense = (item = {}) => {
    this.props.toggleModal({
      show: true,
      props: {
        title: `${item?.id ? "Update" : "Create"} Expense`,
        children: (
          <CreateDealExpense
            editData={item}
            close={this.close}
            currentDeal={this.props.currentDeal?.id}
            updateStats={this.props.updateStats}
          />
        ),
        themeColor: "var(--app-theme)",
        size: "medium",
      },
    });
  };

  DeleteItemfromRedux = (id) => {
    let { currentDeal, deals } = this.props;
    let filteredExpense = currentDeal?.expenses?.filter(
      (item) => item.id !== id
    );
    currentDeal.expenses = filteredExpense;
    this.props.updateItemInredux(deals, currentDeal);
  };

  handleDeleteDealExpense = async (item) => {
    let res = await ApiCallHandler.send(
      URLS.ARCHIVE_DEAL_EXPENSE,
      "POST",
      {
        id: item?.id,
      }
    );
    if (res && res.success) {
      this.DeleteItemfromRedux(res?.data?.id);
      let stats = await this.props.getOppStats(this.props.currentDeal?.id);
      this.props.updateStats(stats?.payload);
      this.props.toggleToast({
        show: true,
        message: "Expense deleted successfully",
        type: "success",
      });
    } else {
      this.props.toggleToast({
        showToast: true,
        message: "An error occurred. Try again",
        type: "failure",
      });
    }
  };

  render() {
    return <div>{this.showDealExpenses()}</div>;
  }
}

const mapStateToProps = (state,ownerProps) => {
  const currentDeal = state.deals.filter(
    (x) => x.id ===ownerProps?.match?.params?.id
  )[0];
    const currentEnterprise = state.enterprises?.find(
      (item) => item.id === getActiveEnterprise()?.id
    );
  return {
    dealExpenses: currentDeal?.expenses,
    expenseTypes: currentDeal?.expense_types,
    currentDeal,
    deals: state.deals,
    currentEnterprise,
    tags:state.tags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleToast: toggleToastAction,
      getOppStats:getDealStatsAction,
      toggleModal: toggleModalAction,
      updateItemInredux: (current_data, new_data) =>
        dispatch(editMutationAction("DEAL", current_data, new_data)),
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListDealExpenses)
);
